import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ValueObject, Result, BadInputError } from '@digibricks/core';
export var OutputStructure = /*#__PURE__*/function (_ValueObject) {
  _inherits(OutputStructure, _ValueObject);

  var _super = _createSuper(OutputStructure);

  function OutputStructure() {
    _classCallCheck(this, OutputStructure);

    return _super.apply(this, arguments);
  }

  _createClass(OutputStructure, [{
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "properties",
    get: function get() {
      return this.props.properties;
    }
  }, {
    key: "required",
    get: function get() {
      return this.props.required;
    }
  }, {
    key: "additionalProperties",
    get: function get() {
      return this.props.additionalProperties;
    }
  }, {
    key: "toJson",
    value:
    /**
     * Convert to JSON object
     */
    function toJson() {
      return _objectSpread(_objectSpread({
        type: this.type,
        properties: this.properties
      }, this.required && {
        required: this.required
      }), this.additionalProperties !== undefined && {
        additionalProperties: this.additionalProperties
      });
    }
  }], [{
    key: "isValid",
    value: function isValid(props) {
      // Must have type
      if (!props.type || props.type.trim().length === 0) {
        return false;
      } // Must have properties object


      if (!props.properties || typeof props.properties !== 'object') {
        return false;
      }

      return true;
    }
  }, {
    key: "create",
    value: function create(props) {
      if (!this.isValid(props)) {
        return new BadInputError('Output structure must have valid type and properties');
      }

      return Result.ok(new OutputStructure(props));
    }
    /**
     * Create from JSON object
     */

  }, {
    key: "fromJson",
    value: function fromJson(json) {
      return this.create({
        type: json.type,
        properties: json.properties || {},
        required: json.required,
        additionalProperties: json.additionalProperties
      });
    }
  }]);

  return OutputStructure;
}(ValueObject);